// extracted by mini-css-extract-plugin
export default {"controls":"Header_controls__SycM3"};